export default "__VITE_ASSET__B9fm_i50__"